/// <reference path="register.module.ts" />
///<reference path="../../components/short-cuts/models/short-cuts-group.model.ts"/>


module Meevo.Plugins.Register {

    import IShortCutGroup = Meevo.Components.ShortCuts.IShortCutGroup;
    import ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;

    export class RegisterController {

        public context: Meevo.Plugins.Register.RegisterContext;
        public ticketItems;
        public showTicketItems: boolean;

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;

        private hotKeysGroup: IShortCutGroup;
        angular = angular;

        static $inject = [
            "meevo.ContextParams",

            "$rootScope",
            "$scope",
            "$mdDialog",
            "$mdToast",
            "$timeout",
            "$http",
            "$translate",
            "$q",
            "$filter",
            "$location",
            "$anchorScroll",

            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.common.PrintService",
            "meevo.components.common.SecurityService",
            "meevo.components.hostedPage.HostedPageService",
            "meevo.components.common.ClientMembershipDataService",
            "meevo.components.common.RoundingService",
            "meevo.components.busy.BusyService",
            "meevo.plugins.register.RebookService",
            "meevo.plugins.register.RegisterTipService",
            "meevo.plugins.register.RegisterNotesService",
            "meevo.plugins.register.RegisterDiscountService",
            "meevo.plugins.register.RegisterGiftCardService",
            "meevo.plugins.register.RegisterCareCreditService",
            "meevo.plugins.register.RegisterTicketService",
            "meevo.plugins.register.RegisterClientAccountService",

            "$state",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.tracking.TrackingService",
            'meevo.plugins.referral.ReferralService',
            "meevo.plugins.register.RegisterPaymentPlanService",
            "meevo.plugins.tippy.tippyService",
            "meevo.plugins.interop.InteropService",
            "meevo.components.logging.LoggingService"
        ];

        constructor(
            contextParams: Meevo.IContextParams,

            public $rootScope: angular.IRootScopeService,
            public $scope: angular.IScope,
            public $mdDialog: angular.material.IDialogService,
            public $mdToast: angular.material.IToastService,
            public $timeout: angular.ITimeoutService,
            public $http: angular.IHttpService,
            public $translate: angular.translate.ITranslateService,
            public $q: ng.IQService,
            public $filter: angular.IFilterService,
            public $location: angular.ILocationService,
            public $anchorScroll: angular.IAnchorScrollService,

            public appSettings: Meevo.Components.Common.IAppSettings,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            public modalService: Meevo.Components.Modal.IModalService,
            public identityService: Meevo.Components.Common.IIdentityService,
            public printService: Meevo.Components.Common.IPrintService,
            public securityService: Meevo.Components.Common.ISecurityService,
            public hostedPageService: Meevo.Components.HostedPage.IHostedPageService,
            public clientMemberDataService: any,
            public roundingService: Meevo.Components.Common.IRoundingService,
            public busyService: Meevo.Components.Busy.IBusyService,
            public rebookService: Meevo.Plugins.Register.RebookService,
            public registerTipService: Meevo.Plugins.Register.RegisterTipService,
            public registerNotesService: Meevo.Plugins.Register.RegisterNotesService,
            public registerDiscountService: Meevo.Plugins.Register.RegisterDiscountService,
            public registerGiftCardService: Meevo.Plugins.Register.RegisterGiftCardService,
            public registerCareCreditService: Meevo.Plugins.Register.RegisterCareCreditService,
            public registerTicketService: Meevo.Plugins.Register.RegisterTicketService,
            public registerClientAccountService: Meevo.Plugins.Register.RegisterClientAccountService,

            private $state: any,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            private trackingService: Meevo.Components.Tracking.ITrackingService,
            public referralService: Meevo.Plugins.Referral.ReferralService,
            public paymentPlanService: Meevo.Plugins.Register.RegisterPaymentPlanService,
            public tippyService: Meevo.Plugins.Tippy.TippyService,
            public interopService: Meevo.Plugins.Interop.InteropService,
            public loggingService: Meevo.Components.Logging.ILoggingService
        ) {
            this.showTicketItems = false;

            this.defineShortCuts();

            this.context = new RegisterContext(this);

            // due to race condition between DrawerManager initialize and Register initialize
            // it was possible this event was fired before it was subscribed to here
            $scope.$on(Meevo.Components.Common.Messages.REGISTER_DRAWER_SELECTED, (event, args, params: any) => {
                if (args.name !== this.appSettings.ROUTE_NAMES.register) {
                    return;
                }

                this.busyService.stop();
                this.drawerSelected(params, contextParams);
            });

            this.context.initialize().then(() => {
                // TODO: see if the rest of these are dependent on anything done in initialize
                this.registerEventHandlers($scope, contextParams);
            });

            $scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
                if (toState.name === this.appSettings.ROUTE_NAMES.register) {
                    this.onRouteActive();
                } else if (fromState.name === this.appSettings.ROUTE_NAMES.register) {
                    this.onRouteInactive();
                }
            });

            this.onRouteActive();
        }

        private registerEventHandlers($scope, contextParams) {
            $scope.$on(Meevo.Components.Common.Messages.CLOSE_DRAWERMANAGER_SECTION, (event, state) => {
                if (state.name !== this.appSettings.ROUTE_NAMES.register) {
                    return;
                }

                this.context.closeDrawerManager();
            });

            $scope.$on(Meevo.Components.Common.Messages.CLOSE_CONTEXT_WARNING, (event, state) => {
                if (state.name !== this.appSettings.ROUTE_NAMES.register) {
                    return;
                }

                this.close(state);
            });

            $scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, (event, state, params) => {
                if (state.name !== this.appSettings.ROUTE_NAMES.register) {
                    return;
                }

                this.applyParamsToContext(params);
            });

            $scope.$on(Meevo.Components.Common.Messages.PRINTER_SELECTED, (event, args, params) => {
                this.context.selectedPrinter = null;
                this.context.selectedPrinter = params;
            });

            $scope.$on(Meevo.Components.Common.Messages.TERMINAL_SELECTED, (event, args, params) => {
                if (args.name !== this.appSettings.ROUTE_NAMES.register) {
                    return;
                }

                this.context.setCreditCardTerminal(params.terminalId);
            });

            $scope.$on(Meevo.Components.Common.Messages.REGISTER_TERMINAL_UPDATE, (event, args, params) => {
                this.context.setSelectedTerminal(params);
            });

            $scope.$on(Meevo.Components.Common.Messages.DRAWER_OPENED, (event, args) => {
                if (args.name !== this.appSettings.ROUTE_NAMES.register) {
                    return;
                }

                this.drawerOpened();
            });

            $scope.$on(Meevo.Components.Common.Messages.DRAWER_CLOSED, (event, args) => {
                if (args.name !== this.appSettings.ROUTE_NAMES.register) {
                    return;
                }

                this.context.selectedDrawer.drawerState = Meevo.Model.DrawerStateEnum.Close;
                this.context.openDrawerManager();
            });

            $scope.$on(Meevo.Components.Common.Messages.DRAWER_CLOSED_BY_ANOTHER_WARNING, (event, msg) => {
                let closeEvent = JSON.parse(msg);
                if (closeEvent.drawerId && closeEvent.closingUserId) {
                    if (this.context.selectedDrawer.id == closeEvent.drawerId && this.identityService.current().userId != closeEvent.closingUserId) {
                        this.modalService.alert("MESSAGE_DRAWER_CLOSED");
                    }
                }
            });

            $scope.$on(Meevo.Components.Common.Messages.TIPPY_TIPS_SELECTED, (event, transactionId) => {
                this.tippyService.tipsSelected(transactionId);
            });

            //Listener for server side broadcast of merchant account tip setting changes
            //See pushMessageHandler.ts for hook.
            $scope.$on(Meevo.Components.Common.Messages.ENABLE_TIPS_SETTING_UPDATED, () => {
                this.context.setMerchantAccount(this.context.selectedDrawer).then(() => {
                    this.context.setCreditCardTerminal(this.context.selectedTerminal.id);
                });
            });

            $scope.$on(Meevo.Components.Common.Messages.NO_SALE_SELF_PAYMENT_ENTITY_VERSION_VALIDATION_FAILURE, (event, args) => {
                this.context.clearSaleSelfPaymentEntityVersionValidationFailure(args.retainCareCredit);
            });

            // register handles context params on drawer selection except for insert transaction from past
            if (contextParams && contextParams.params) {
                switch (contextParams.params.action) {
                    case Meevo.Components.Common.Messages.TRANSACTION_EDITOR_INSERT:
                        this.processParams(contextParams.params);
                        contextParams.params = null;
                        break;
                }
            }
        }

        private drawerOpened() {
            this.context.selectedDrawer.drawerState = Meevo.Model.DrawerStateEnum.Open;
            if (this.context.sale.saleLines.length > 0) {
                this.context.recalculateSale();

                if (device.mobile()) {
                    this.context.selectSection(RegisterSectionTypeEnum.Ticket);
                } else {
                    this.context.selectSection(RegisterSectionTypeEnum.Services);
                }
            }
            else if (this.context.selectedClient || this.context.selectedClientType) {
                this.context.selectSection(device.mobile() ? RegisterSectionTypeEnum.Ticket : RegisterSectionTypeEnum.Services);
            }
            else {
                this.context.selectSection(RegisterSectionTypeEnum.Client);
            }
        }

        private drawerSelected(params, contextParams) {
            if (this.registerTicketService.isPastTransactionMode) {
                const pastTransactionContext = this.registerTicketService.getPastTransactionContext();

                if (pastTransactionContext && !pastTransactionContext.selectedDrawer.id) {
                    pastTransactionContext.selectedDrawer = angular.copy(params.selectedDrawer);
                }
            }

            const previousDrawer = this.context.selectedDrawer;
            this.context.selectedDrawer = params.selectedDrawer;
            this.context.recordDrawerSelected(previousDrawer, params.selectedDrawer, params.reason);
            const promise = this.context.setMerchantAccount(params.selectedDrawer);
            this.context.selectedTerminal = params.selectedCreditCardTerminal;
            this.context.printService.setSelectedTerminal(this.context.selectedTerminal)
            this.context.selectedPrinter = params.selectedPrinter;

            if (!this.context.isSelectedDrawerOpen()) {
                this.context.openDrawerManager();
            }
            else {
                if (this.context.sale && this.context.sale.saleLines && this.context.sale.saleLines.length > 0) {
                    this.context.recalculateSale().then(() => {
                        this.context.selectSection(device.mobile() ? RegisterSectionTypeEnum.Ticket : RegisterSectionTypeEnum.Services);
                    });
                }
                else if (this.context.selectedClient || this.context.selectedClientType) {
                    this.context.selectSection(device.mobile() ? RegisterSectionTypeEnum.Ticket : RegisterSectionTypeEnum.Services);
                }
                else {
                    this.context.selectSection(RegisterSectionTypeEnum.Client);
                }
            }

            promise.finally(() => {
                const otherSection = <OtherPaymentsSection> this.context.sections.find(section => section.constructor === OtherPaymentsSection)
                if (otherSection) {
                    otherSection.otherSurcharges = undefined;
                }
                if (contextParams.params) {
                    this.processParams(contextParams.params);
                    contextParams.params = null;
                }
            });
        }

        private applyParamsToContext(params) {
            if (!angular.isDefined(params)) {
                return;
            }

            if (!this.context.isDirty()) {
                this.context.reset(false);
                this.processParams(params);
                return;
            }

            this.context.returnStateClient = undefined;
            this.getUserActionForCurrentTransaction(true).then(() => {
                this.processParams(params);
            });
        }

        private defineShortCuts() {
            this.hotKeysGroup = new ShortCutGroup([
                {
                    shortCutName: 'REGISTER_POP_DRAWER', callback: () => {
                        if (angular.element('.pop-drawer-btn').length) {
                            this.context.popDrawer();
                        }
                    }
                },
                {
                    shortCutName: 'REGISTER_PAY_NOW', callback: () => {
                        if (this.context.canFinalize() && this.canClickSmartTicketFooter()) {
                            this.context.finishSection();
                        }
                    }
                },
                {
                    shortCutName: 'REGISTER_NO_SALE', callback: () => {
                        if (this.context.canDoNoSale()
                            && this.context.isDirty(true)
                            && this.canClickSmartTicketFooter()) {
                            this.noSale();
                        }
                    }
                },
                {
                    shortCutName: 'REGISTER_HOLD', callback: () => {
                        if (this.context.canHold() && this.canClickSmartTicketFooter()) {
                            this.context.onHold();
                        }
                    }
                },
                {
                    shortCutName: 'REGISTER_BACK_TO_SALE', callback: () => {
                        const selectedSection = this.context.selectedSection;

                        if (this.context.isRefundMode) {
                            this.context.backToSale();
                        }
                        else if (selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Sale) {
                            this.$timeout(() => {
                                angular.element('#backNavigationButton').triggerHandler('click');
                            });
                        }
                        else if (selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Payment
                            || selectedSection.sectionType === RegisterSectionTypeEnum.Discounts
                            || selectedSection.sectionType === RegisterSectionTypeEnum.PromotionalGiftCard
                            || selectedSection.sectionType === RegisterSectionTypeEnum.RefundReason) {
                            this.context.selectSection(RegisterSectionTypeEnum.Services);
                        }
                        else { //selectedSection.sectionCatType is other
                            this.context.selectedSection['showOnHold'] = false;
                            this.context.selectedSection['showCancelNoShow'] = false;
                        }
                    }
                },
                {
                    shortCutName: 'REGISTER_RETURN_TRANSACTION', callback: () => {
                        const specifyClientSection = this.context.selectedSection as SpecifyClientSection;

                        if (specifyClientSection && specifyClientSection.gotoReturnTransaction) {
                            specifyClientSection.gotoReturnTransaction();
                        } else if (this.context.canRefund() && this.canClickSmartTicketFooter()) {
                            this.context.refund();
                        }
                    }
                },
            ], { noun: Meevo.Model.NounEnum.Register });
        }

        private onRouteActive(): void {
            this.bindHotkeys();
        }

        private onRouteInactive(): void {
            this.unbindHotkeys();
        }

        private processParams(params) {
            this.context.clearSaleSyncAppointmentUpdates();
            switch (params.action) {
                case Meevo.Components.Common.Messages.RETURN_FROM_ON_HOLD:
                    this.context.sale.mergeOnHoldId = params.id;
                    this.context.recalculateSale(false, null, true);
                    break;
                case Meevo.Components.Common.Messages.PACKAGE_TRANSFER:
                    this.context.addClientPackageTransferSaleLine(params);
                    break;
                case Meevo.Components.Common.Messages.REGISTER_REFUND_RECEIPT:
                    this.context.getSaleLinesToRefundFromTransactionId(params.transactionNumber, true, true);
                    break;
                case Components.Common.Messages.MANUAL_BILL_PAYMENT:
                    this.context.addManualBillPaymentSaleLine(params, false);
                    break;
                case Components.Common.Messages.MANUAL_PAYMENT_PLAN_BILL_PAYMENT:
                    this.context.addManualPaymentPlanBillPaymentSaleLine(params);
                    break;
                case Components.Common.Messages.MANUAL_BILL_PAYMENT_REFUND:
                    this.context.addManualBillPaymentSaleLine(params, true);
                    break;
                case Components.Common.Messages.MANUAL_SALE_LINE:
                    this.context.addManualSaleLine(params);
                    break;
                case Components.Common.Messages.MANUAL_SALE_LINES:
                    this.context.addManualSaleLines(params);
                    break;
                case Components.Common.Messages.REGISTER_RELOAD_CLIENT_GIFTCARD:
                    var clientId = params.clientId;
                    var gcId = params.gcId;
                    var gcNumber = params.gcNumber;
                    var gcAmount = params.gcAmount;
                    this.context.populateFromGiftCardReload(clientId, gcId, gcNumber, gcAmount);
                    break;
                case Components.Common.Messages.TRANSACTION_EDITOR_INSERT:
                    this.context.enterRegisterPastTransactionMode(params.pastTransactionContext);
                    break;
                case Components.Common.Messages.ADD_PAYMENT_REQUEST_TO_SALE:
                    this.context.addPaymentRequestToSale(params);
                    break;
                case Components.Common.Messages.CHECKOUT_APPT_SERVICES:
                default:
                    if (params.pastTransactionContext) {
                        this.context.enterRegisterPastTransactionMode(params.pastTransactionContext);
                    }

                    if (params.isAnonymousClientCheckout) {
                        this.context.clientContext.addClientAppointmentsByInitiatingServiceId(params.id);
                        return;
                    }

                    this.context.populateFromAppointmentServices(params.services, params.actionDetails, params.appointmentEntityVersion);
                    break;
            }
        }

        public itemCountNotification = () => {
            this.showTicketItems = true;
            this.ticketItems = this.context.getQuantityByType();
            this.$timeout(5000).then(() => { this.showTicketItems = false; });
        }

        confirmIfDirtyThenAction(callback: any, bypassConfirmation?: boolean): void {
            if (this.context.isDirty(true)) {
                if (this.registerCareCreditService.handleCareCreditNoSaleMessage(this.context)) {
                    return;
                }

                if (!this.context.getMerchantAccountCanVoidRefunds()) {
                    const creditPayments = _(this.context.sale.paymentLines).filter(paymentLine => paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CreditDebit && !paymentLine.isAuthorization);
                    let hasCreditRefund = _(creditPayments).any(paymentLine => paymentLine.amount < 0);
                    if (hasCreditRefund) {
                        this.modalService.alert('MESSAGE_REGISTER_CONFIRM_NOSALE_WITH_CREDIT_REFUND');
                        return;
                    }
                }

                let hasCreditCard = (this.context.creditCardProcessingEnabled && _(this.context.sale.paymentLines).any(paymentLine => paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CreditDebit));
                let hasOnHold = (Object.keys(this.context.sale.onHoldIds).length > 0) && this.context.explicitHoldAdded;

                let messageId = "MESSAGE_REGISTER_CONFIRM_CLOSE";

                if (hasOnHold && hasCreditCard) {
                    messageId = this.context.selectedMerchantAccount.canVoidTransactions
                        ? "MESSAGE_REGISTER_CONFIRM_NOSALE_HOLD_WITH_CC"
                        : "MESSAGE_REGISTER_CONFIRM_NOSALE_HOLD_WITH_CC_REVERSAL";
                }
                else if (hasOnHold) {
                    messageId = "MESSAGE_REGISTER_CONFIRM_NOSALE_HOLD";
                }
                else if (hasCreditCard) {
                    messageId = this.context.selectedMerchantAccount.canVoidTransactions
                        ? "MESSAGE_REGISTER_CONFIRM_NOSALE_WITH_CC"
                        : "MESSAGE_REGISTER_CONFIRM_NOSALE_WITH_CC_REVERSAL";
                }

                if (bypassConfirmation && messageId === "MESSAGE_REGISTER_CONFIRM_CLOSE") {
                    callback();
                }
                else {
                    this.modalService.confirm(messageId).then(() => {
                        callback();
                    });
                }
            } else {
                callback();
            }
        }

        closeTab(state) {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, state || this.$state.current, null);
        }

        closeClick() {
            this.usageTrackingLog(Meevo.Model.VerbEnum.CloseButtonClicked);
            this.close();
        }

        close(state?): void {
            if (this.context.isDirty()) {
                this.getUserActionForCurrentTransaction(true).then(() => {
                    this.closeTab(state);
                });
            }
            else {
                this.closeTab(state);
            }
        }

        noSaleClick() {
            this.usageTrackingLog(Meevo.Model.VerbEnum.NoSaleClicked);
            this.noSale();
        }

        noSale(bypassConfirmation?: boolean): ng.IPromise<any> {
            let deferred = this.$q.defer();

            this.context.cancelPendingHostedPagePayments().finally(() => {
                if (this.context.hasPendingPayment()) {
                    this.modalService.alert("MESSAGE_PAYMENT_BEING_PROCESSED");
                    deferred.reject();
                    return deferred.promise;
                }

                this.confirmIfDirtyThenAction(() => {
                    if (this.context.selectedMerchantAccount && !this.context.selectedMerchantAccount.canVoidTransactions && this.context.hasCreditDebitPayment()) {
                        // reverse the credit card transactions in the sale
                        this.context.reverseCreditDebitPayments()
                            .then((succeeded) => {
                                if (succeeded) {
                                    this.context.clearSale(deferred);
                                }
                                else {
                                    deferred.reject();
                                }
                            })
                            .catch(() => {
                                deferred.reject();
                            });
                    }
                    else {
                        this.context.clearSale(deferred);
                    }
                }, bypassConfirmation);
            });

            return deferred.promise;
        }

        getRegisterActionPromptModalOptions(messageText?: string) {
            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/registerActionPromptTemplate.html",
                controller: "meevo.plugins.register.RegisterActionPromptController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    canHold: this.context.canHold(),
                    canFinalize: this.context.canFinalize(),
                    isFinalize: this.context.isFinalize(),
                    messageText: messageText
                }
            };

            return modalOptions;
        }

        getUserActionForCurrentTransaction(bypassSucceedingConfirmation?: boolean, messageText?: string): ng.IPromise<any> {
            let modalOptions = this.getRegisterActionPromptModalOptions(messageText);

            return this.modalService
                .showCustom(modalOptions)
                .then((response) => {
                    let deferred = this.$q.defer();

                    switch (response.action) {
                        case RegisterActionPromptResponseEnum.NoSale:
                            this.securityService.canExecute(this.securityKeys.REGISTER_REGISTER_ACTION_NOSALE, this.$scope)
                                .then(() => {
                                    deferred.resolve(this.noSale(bypassSucceedingConfirmation));
                                })
                                .catch(() => {
                                    deferred.reject();
                                });
                            break;

                        case RegisterActionPromptResponseEnum.OnHold:
                            this.securityService.canExecute(this.securityKeys.REGISTER_REGISTER_SALEHOLD_ACTION_ADD, this.$scope)
                                .then(() => {
                                    deferred.resolve(this.context.onHold());
                                })
                                .catch(() => {
                                    deferred.reject();
                                });
                            break;

                        case RegisterActionPromptResponseEnum.NoAction:
                            deferred.reject();
                            break;

                        case RegisterActionPromptResponseEnum.Finalize:
                        default:
                            if (this.context.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Sale ||
                                this.context.selectedSection.sectionType === RegisterSectionTypeEnum.Client) {
                                this.context.finishSection();
                            }
                            deferred.reject();
                            break;
                    }

                    return deferred.promise;
                });
        }

        /////////Mobile register ng-hide logic///////////
        //ng-hide. true = hidden, false = visible

        mobileRegisterRight(section: number) {
            if (!device.mobile() && !device.tablet()) {
                return false;
            } else if (device.ipad() && !device.portrait()) {
                //ipad landscape, shows desktop version
                return false;
            } else if (device.largeTablet()) {
                //ipad pro sized device
                return false;
            } else if ((device.mobile() || (device.tablet() && device.portrait() && !device.largeTablet())) &&
                (section === RegisterSectionTypeEnum.Ticket ||
                this.isPaymentPlanPaymentSelectSaleLineMode(section))){
                //mobile device, ipad portrait
                //mobile navigation flow
                //section is hidden, ticket should be displayed
                return true;
            } else {
                return false;
            }
        }

        mobileRegisterContext(section: number) {
            if (!device.mobile() && !device.tablet()) {
                return false;
            } else if (device.ipad() && !device.portrait()) {
                //ipad landscape, shows desktop version
                return false;
            } else if (device.largeTablet()) {
                //ipad pro sized device
                return false;
            } else if ((device.mobile() || (device.tablet() && device.portrait() && !device.largeTablet())) && section === RegisterSectionTypeEnum.Buttons || section === RegisterSectionTypeEnum.Ticket) {
                //if section is ticket or button column
                //section is hidden, register context should not be displayed
                return true;
            } else {
                return false;
            }
        }

        mobileRegisterButton(section: number) {
            if (!device.mobile() && !device.tablet()) {
                return false;
            } else if (device.ipad() && !device.portrait()) {
                //ipad landscape, shows desktop version
                return false;
            } else if (device.largeTablet()) {
                //ipad pro sized device
                return false;
            } else if ((device.mobile() || (device.tablet() && device.portrait() && !device.largeTablet())) && section === RegisterSectionTypeEnum.Buttons) {
                //sale button section is displayed, buttons should be displayed
                return false;
            } else if ((device.mobile() || (device.tablet() && device.portrait() && !device.largeTablet())) && section === RegisterSectionTypeEnum.Payment) {
                //payemnt button section is displayed, buttons should be displayed
                return false;
            } else {
                return true;
            }
        }

        mobileRegisterTicket(section: number) {
            if (!device.mobile() && !device.tablet()) {
                return false;
            } else if (device.tablet() && !device.portrait()) {
                //ipad landscape, shows desktop version
                return false;
            } else if (device.largeTablet()) {
                //ipad pro sized device
                return false;
            } else if ((device.mobile() || (device.tablet() && device.portrait() && !device.largeTablet())) &&
                (section === RegisterSectionTypeEnum.Ticket || this.isPaymentPlanPaymentSelectSaleLineMode(section))) {
                //section is displayed, register ticket should be displayed
                return false;
            } else {
                return true;
            }
        }

        private isPaymentPlanPaymentSelectSaleLineMode(section: number) {
            return !this.context.isRefundMode && section === RegisterSectionTypeEnum.PaymentPlan &&
                this.context.paymentPlanPaymentsSection.isSaleLineSelectionMode;
        }

        private bindHotkeys(): void {
            if (_.isEmpty(this.shortCutsService) || _.isEmpty(this.$scope)) {
                return;
            }

            this.shortCutsService.activateGroup(this.hotKeysGroup);
        }

        private unbindHotkeys(): void {
            this.shortCutsService.deactivateGroup(this.hotKeysGroup);
        }

        private canClickSmartTicketFooter(): boolean {
            return !(this.context.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Payment
                || this.context.isRefundMode
                || this.context.selectedSection.sectionType === RegisterSectionTypeEnum.Discounts
                || this.context.selectedSection.sectionType === RegisterSectionTypeEnum.PromotionalGiftCard
                || this.context.selectedSection.sectionType === RegisterSectionTypeEnum.RefundReason);
        }

        usageTrackingLog(verbEnum: Meevo.Model.VerbEnum): void {
            this.trackUsage(Meevo.Model.NounEnum.RegisterPage, verbEnum);
        }

        public trackUsage(nounEnum: Meevo.Model.NounEnum, verbEnum: Meevo.Model.VerbEnum) {
            var trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, null, null);
            this.trackingService.saveTrackingInfo(trackingItem);
        }
        /////////////////
    }

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.RegisterController", RegisterController);
}
